/** Values used in the Alarm Settings UI multi-select (match API flags). */
export const ALERT_REPORT_TYPE_VALUES = [
    "lowTemperature",
    "highTemperature",
    "lowCo2",
    "highCo2",
    "lowHumidity",
    "highHumidity",
    "noNodeCommunication",
    "noApCommunication",
    "reporting",
];
/** The CO2 / humidity choices exist only for new hardware; elsewhere they are neither shown nor sent. */
export const SENSOR_CHOICE_VALUES = ["lowCo2", "highCo2", "lowHumidity", "highHumidity"];
export function booleansToAlertReportTypes(r, hasSensorChoices = false) {
    const out = [];
    if (r.allowLowTemp)
        out.push("lowTemperature");
    if (r.allowHighTemp)
        out.push("highTemperature");
    if (hasSensorChoices) {
        if (r.allowLowCo2)
            out.push("lowCo2");
        if (r.allowHighCo2)
            out.push("highCo2");
        if (r.allowLowHumidity)
            out.push("lowHumidity");
        if (r.allowHighHumidity)
            out.push("highHumidity");
    }
    if (r.allowNoNode)
        out.push("noNodeCommunication");
    if (r.allowNoAp)
        out.push("noApCommunication");
    if (r.allowReporting)
        out.push("reporting");
    return out;
}
export function alertReportTypesToBooleans(types, hasSensorChoices = false) {
    return Object.assign(Object.assign({ allowLowTemp: types.includes("lowTemperature"), allowHighTemp: types.includes("highTemperature") }, (hasSensorChoices && {
        allowLowCo2: types.includes("lowCo2"),
        allowHighCo2: types.includes("highCo2"),
        allowLowHumidity: types.includes("lowHumidity"),
        allowHighHumidity: types.includes("highHumidity"),
    })), { allowNoNode: types.includes("noNodeCommunication"), allowNoAp: types.includes("noApCommunication"), allowReporting: types.includes("reporting") });
}
